import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service';
import { fuseAnimations } from '../../../core/animations';

import { locale as english } from './i18n/en';
import { locale as turkish } from './i18n/tr';

@Component({
    selector   : 'fuse-sample',
    templateUrl: './landing.component.html',
    styleUrls  : ['./landing.component.scss'],
    animations : fuseAnimations
})
export class LandingComponent
{
    constructor(private translationLoader: FuseTranslationLoaderService,
                private router: Router)
    {
        //this.translationLoader.loadTranslations(english, turkish);
    }

    viewReports() {
        console.log("Before navigate to pages/pick-kidney/me");
       // this.router.navigate(['/pages/score/latest'])
       this.router.navigate(['/pages/pick-kidney/me'])
    }
    compareReports() {
        console.log("Before navigate to pages/pick-kidney/compare");
        // this.router.navigate(['/pages/score/latest'])
        this.router.navigate(['/pages/pick-kidney/compare']) 
    }
    newSurgery() {
        console.log("Before navigate to surgery-type")
        this.router.navigate(['/pages/surgery-type']);
    }

    uploadData() {
        console.log("Before navigate to upload-data")
        this.router.navigate(['/pages/upload-data']);
    }
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/main/content/landing/landing.component.ts